import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getFromStorage } from "utils/localStorage";

export const customBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_URL,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    const token = getFromStorage("token");
    const secretKey = getFromStorage("secret-key");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    if (secretKey) {
      headers.set("secret-key", secretKey);
    }

    return headers;
  },
});
